"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineChart = void 0;
var Highcharts = __importStar(require("highcharts"));
var exporting_1 = __importDefault(require("highcharts/modules/exporting"));
var series_label_1 = __importDefault(require("highcharts/modules/series-label"));
var chart_config_1 = require("./chart-config");
var utils_1 = require("./utils");
(0, exporting_1.default)(Highcharts);
(0, series_label_1.default)(Highcharts);
var SERIE_LABEL_MAX_LENGTH = 30;
var MAX_DATASET_SERIES_LABEL = 5;
var lineChart = function (sortedDates, data, dateFormatter, renderElementId, options) {
    if (options === void 0) { options = {}; }
    return Highcharts.chart({
        chart: {
            renderTo: renderElementId,
            height: chart_config_1.chartHeight,
            spacing: [10, 10, 20, 20],
            marginTop: 65,
        },
        colors: chart_config_1.lineChartColors,
        title: {
            text: options.name,
            useHTML: true,
            align: 'left',
            margin: 20,
            widthAdjust: -180,
            style: chart_config_1.chartTitleStyle,
        },
        subtitle: {
            text: options.subtitle,
            //useHTML: true,
            widthAdjust: 0,
            align: 'left',
            style: {
                color: '#333',
                fontWeight: '500',
                fontSize: '12px',
                lineHeight: '16px',
                letterSpacing: '0.2px',
                fontFamily: "'Montserrat', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji'",
                zIndex: 1,
            },
        },
        series: data.map(function (dataset) { return ({
            type: 'line',
            name: dataset.name || '',
            label: {
                formatter: function () {
                    if (data.length > MAX_DATASET_SERIES_LABEL) {
                        return '';
                    }
                    var label = this.name || '';
                    return label.length > SERIE_LABEL_MAX_LENGTH ? label.substring(0, SERIE_LABEL_MAX_LENGTH) + "\u2026" : label;
                },
            },
            data: sortedDates.map(function (date) {
                return dataset.values[date].value;
            }),
            dataLabels: {
                enabled: true,
                formatter: function () {
                    return this ? (0, utils_1.formatNumberValue)(this.y || 0) : null;
                },
                y: 25,
                style: chart_config_1.dataLablesLineChartFontStyle,
            },
        }); }),
        xAxis: {
            /*crosshair: {
                width: 2,
            },*/
            title: {
                margin: 10,
                style: chart_config_1.axisTitleChartFontStyle,
            },
            categories: sortedDates.map(function (date) { return dateFormatter(new Date(date)); }),
            showLastLabel: false,
            tickWidth: 0,
            tickLength: 0,
            lineWidth: 0,
            gridLineWidth: 1,
            gridLineDashStyle: 'Dash',
            gridLineColor: '#ccc',
            labels: {
                align: 'center',
                y: 16,
                style: chart_config_1.axisChartLabelFontStyle,
            },
        },
        yAxis: [
            {
                // left y axis
                crosshair: {
                    width: 1,
                    color: 'rgba(81, 80, 169, .2)',
                },
                title: {
                    text: options.yAxisName || 'Cena',
                    margin: 0,
                    x: -12,
                    style: chart_config_1.axisTitleChartFontStyle,
                },
                tickLength: 0,
                minorTickLength: 0,
                minorGridLineWidth: 0,
                gridLineColor: '#ccc',
                gridLineDashStyle: 'Dash',
                labels: {
                    align: 'left',
                    x: 4,
                    y: 16,
                    style: chart_config_1.axisChartLabelFontStyle,
                    formatter: function (label) {
                        if (options.unit) {
                            return "" + (0, utils_1.formatValue)(Number(label.value)) + options.unit;
                        }
                        return "" + (0, utils_1.formatValue)(Number(label.value));
                    },
                },
                showFirstLabel: false,
            },
        ],
        lang: chart_config_1.langConfigCs,
        exporting: (0, chart_config_1.exportingConfig)({
            filename: options.exportFilename,
            chartOptions: {
                legend: {
                    width: 1380,
                    itemWidth: 345,
                },
                chart: {
                    spacing: [10, 10, 10, 10],
                    events: {
                        load: function () {
                            this.renderer
                                .image('data:image/svg+xml;base64,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', 1190, 10, 200, 50)
                                .add();
                        },
                    },
                },
            },
        }),
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            borderWidth: 0,
            x: -2,
            margin: 5,
            symbolWidth: 8,
            symbolHeight: 8,
            symbolRadius: 4,
            itemMarginBottom: 8,
            useHTML: true,
            itemWidth: 300,
            itemStyle: {
                color: '#333',
                fontWeight: '600',
                fontSize: '11px',
                lineHeight: '16px',
                fontFamily: "'Montserrat', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji'",
            },
        },
        tooltip: {
            shared: true,
            borderRadius: 0,
            borderWidth: 0,
            padding: 0,
            shadow: false,
            useHTML: true,
            borderColor: '#000',
            backgroundColor: '#FFF',
            formatter: function () {
                var _a;
                return "<div style=\"background: #fff;padding: 6px 8px 8px 8px;border:1px solid #000;\">\n\t\t\t\t\t<table cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" class=\"table-timeline-tooltip table-line-chart\">\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th colspan=\"2\" class=\"tooltip-h2\">" + this.x + "</th>\n\t\t\t\t\t\t</tr>" + ((_a = this.points) === null || _a === void 0 ? void 0 : _a.reduce(function (string, point) { return string + "<tr><td><i class=\"name-point\" style=\"background: " + point.color + "\"></i><span class=\"name-size-300\">" + point.series.name + "</span>:&nbsp;</td>\n\t\t\t\t\t\t\t<td class=\"td-right\" style=\"text-align: right\"><strong>" + (0, utils_1.formatMoney)(point.y || 0, 2, "" + (typeof options.unit !== 'undefined' ? options.unit : '\u00A0Kč')) + "</strong></td></tr>"; }, '')) + "</table></div>";
            },
            valueDecimals: 2,
            style: {
                color: '#000',
                fontSize: '12px',
                fontFamily: chart_config_1.chartFonts,
            },
        },
        plotOptions: {
            series: {
                lineWidth: 2,
                marker: {
                    symbol: 'circle',
                    radius: 4,
                },
                states: {
                    inactive: {
                        opacity: 1,
                    },
                },
            },
        },
        credits: {
            enabled: false,
        },
    });
};
exports.lineChart = lineChart;
